import { produce } from "immer";
import {
    AUTH_VERIFY_MOBILE_APP_ACTION,
    AUTH_VERIFY_MOBILE_APP_FAILURE,
    AUTH_VERIFY_MOBILE_APP_SUCCESS
} from "../../mobileAppCore/mobileAppConstants";
import parseAccountName from "../../utils/parseAccountName";
import { LOGOUT_SUCCESS } from "../Login/loginConstants";
import {
    ADD_MARKET_DATA_CANDLE_WATCH_ACTION,
    ADD_MARKET_DATA_WATCH_ACTION,
    CHART_TIMEFRAMES,
    CLOSE_ALL_POSITIONS_ACTION,
    CLOSE_ALL_POSITIONS_FAILURE,
    CLOSE_ALL_POSITIONS_SUCCESS,
    GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS,
    GET_LITE_TRADE_ASSETS_SUCCESS,
    GET_LITE_TRADE_MARKET_COLLECTION_SUCCESS,
    GET_LITE_TRADE_MARKET_SUCCESS,
    INIT_LITE_TRADE_ACTION,
    INIT_LITE_TRADE_FAILURE,
    INIT_LITE_TRADE_SUCCESS,
    INIT_UPS_DOWNS_COLLECTION_ACTION,
    INIT_UPS_DOWNS_COLLECTION_FAILURE,
    INIT_UPS_DOWNS_COLLECTION_SUCCESS,
    LOGIN_LITE_TRADE_ACTION,
    LOGIN_LITE_TRADE_FAILURE,
    LOGIN_LITE_TRADE_SUCCESS,
    PING_LITE_TRADE_ACTION,
    PING_LITE_TRADE_FAILURE,
    PING_LITE_TRADE_SUCCESS,
    REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION,
    REMOVE_MARKET_DATA_WATCH_ACTION,
    SET_LITE_TRADE_ACCOUNT_METRICS,
    SET_LITE_TRADE_ACCOUNT_PORTFOLIO,
    SET_LITE_TRADE_SOCKET_STATE,
    TChartTimeframes,
    TRADING_VIEW_SELECTED_TIMEFRAMES_KEY,
    UPDATE_LITE_TRADE_CHART_DATA_READY,
    UPDATE_LITE_TRADE_CHART_TIMEFRAMES,
    UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_ACTION,
    UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_FAILURE,
    UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_SUCCESS,
    UPDATE_LITE_TRADE_ORDER_ACTION,
    UPDATE_LITE_TRADE_ORDER_FAILURE,
    UPDATE_LITE_TRADE_ORDER_SUCCESS,
    UPDATE_LITE_TRADE_POSITION_ACTION,
    UPDATE_LITE_TRADE_POSITION_FAILURE,
    UPDATE_LITE_TRADE_POSITION_SUCCESS,
    UPDATE_MARKET_DATA,
    UPDATE_MARKET_DATA_CANDLE,
    SET_DESKTOP_TRADE_TABLE_MODE,
    UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_SUCCESS,
    UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_POSITION_CODE_ACTION,
    SET_CHART_DRAW_PANEL_OPENED,
} from "./liteTradeConstants";

import {
    IFullLiteTradeAppActionTypes,
    ILiteTradeAssetSymbol,
    ILiteTradeState,
    TDesktopTradeTableMode
} from "./types/liteTradeReducer.t";
import _ from "lodash";
import getLocalStorageState from "../../utils/storage/getLocalStorageState";

const getClearDataFromStorage = (): TChartTimeframes => {
    const savedValue = localStorage.getItem(TRADING_VIEW_SELECTED_TIMEFRAMES_KEY);
    if (savedValue in CHART_TIMEFRAMES) {
        return savedValue as TChartTimeframes;
    }
    localStorage.setItem(TRADING_VIEW_SELECTED_TIMEFRAMES_KEY, '15');
    return '15';
}

const DESKTOP_TRADE_TABLE_MODE_STORAGE_KEY = 'TradePageFooterMode';
export const TRADING_VIEW_STORAGE_KEY_CHART_DRAWING_TOOLBAR_VISIBLE = 'tradingview.ChartDrawingToolbarWidget.visible';
const [initialDesktopTradeTableMode, setDesktopTradeTableMode] = getLocalStorageState<TDesktopTradeTableMode>(DESKTOP_TRADE_TABLE_MODE_STORAGE_KEY, 'positions', (v): v is TDesktopTradeTableMode => {
    const modes: TDesktopTradeTableMode[] = ['positions', 'orders', 'trades_history'];
    return modes.includes(v);
});

const initialState: ILiteTradeState = {
    liteTradeConfig: null,
    liteTradeConfigError: null,
    liteTradeConfigIsLoading: false,

    liteTradePingOk: false,
    liteTradePingError: null,
    liteTradePingIsLoading: false,

    liteTradeSocketState: 0,

    liteTradeSession: {
        sessionToken: null
    },
    loginError: null,
    isLoginLoading: false,

    metrics: {},
    portfolios: {},
    portfoliosInitialized: {},
    marketDataWatchers: [],
    marketDataCandleWatchers: [],

    positionPlLastSeenSigns: {},

    marketData: {},
    marketDataCandle: {},

    assets: [],
    assetsIsLoading: true,

    collections: [],
    collectionsIsLoading: true,
    widgets: [],

    collectionUpsDownsAssetsList: [],
    collectionUpsDownsIsLoading: false,

    authVerifyInProgress: false,

    stat_pl: {
        preset: "",
        pl: ""
    },

    marketFavoriteInProgress: false,

    chart: {
        timeframes: getClearDataFromStorage(),
        dataReady: false
    },

    closeAllPositionsInProgress: false,
    updatePositionInProgress: false,
    updateOrderInProgress: false,

    desktopTradeTableMode: initialDesktopTradeTableMode || 'positions',
    isChartDrawPanelOpened: localStorage.getItem(TRADING_VIEW_STORAGE_KEY_CHART_DRAWING_TOOLBAR_VISIBLE) === 'true' || false,
}


const liteTradeReducer = (state: ILiteTradeState = initialState, action: IFullLiteTradeAppActionTypes) =>
    produce(state, (draft: ILiteTradeState) => {
        switch (action.type) {

            case INIT_LITE_TRADE_ACTION:
                draft.liteTradeConfigError = null;
                draft.liteTradeConfigIsLoading = true;
                break;
            case INIT_LITE_TRADE_SUCCESS:
                draft.liteTradeConfig = action.payload;
                draft.liteTradeConfigIsLoading = false;
                break;
            case INIT_LITE_TRADE_FAILURE:
                draft.liteTradeConfigError = action.payload;
                draft.liteTradeConfigIsLoading = false;
                break;

            case PING_LITE_TRADE_ACTION:
                draft.liteTradePingError = null;
                draft.liteTradePingIsLoading = true;
                break;
            case PING_LITE_TRADE_SUCCESS:
                draft.liteTradeSession = action.payload;
                draft.liteTradePingIsLoading = false;
                draft.liteTradePingOk = true;
                break;
            case PING_LITE_TRADE_FAILURE:
                draft.liteTradePingError = action.payload;
                draft.liteTradePingIsLoading = false;
                draft.liteTradePingOk = false;
                break;

            case SET_LITE_TRADE_SOCKET_STATE:
                draft.liteTradeSocketState = action.payload;
                break;

            case LOGIN_LITE_TRADE_ACTION:
                draft.loginError = null;
                draft.isLoginLoading = true;
                break;
            case LOGIN_LITE_TRADE_SUCCESS:
                draft.liteTradeSession = action.payload;
                draft.isLoginLoading = false;
                draft.liteTradePingOk = true;
                break;
            case LOGIN_LITE_TRADE_FAILURE:
                draft.loginError = action.payload;
                draft.isLoginLoading = false;
                break;

            case SET_LITE_TRADE_ACCOUNT_METRICS:
                const accountCodeMetrics = parseAccountName(action.payload.account)?.accountCode;
                if (!accountCodeMetrics) break;
                draft.metrics[accountCodeMetrics] = action.payload;
                break;

            case SET_LITE_TRADE_ACCOUNT_PORTFOLIO:
                const accountCodePortfolio = parseAccountName(action.payload.account)?.accountCode;
                if (!accountCodePortfolio) break;
                draft.portfolios[accountCodePortfolio] = action.payload;
                draft.portfoliosInitialized[accountCodePortfolio] = true;
                break;

            case GET_LITE_TRADE_ASSETS_SUCCESS:
                draft.assets = action.payload;
                draft.assetsIsLoading = false;
                break;

            case LOGOUT_SUCCESS:
                return {
                    ...initialState,
                };

            case AUTH_VERIFY_MOBILE_APP_ACTION:
                draft.authVerifyInProgress = true;
                break;
            case AUTH_VERIFY_MOBILE_APP_SUCCESS:
                draft.authVerifyInProgress = false;
                break;
            case AUTH_VERIFY_MOBILE_APP_FAILURE:
                draft.authVerifyInProgress = false;
                break;

            case UPDATE_MARKET_DATA:
                action.payload.forEach((event) => {
                    draft.marketData[event.symbol as ILiteTradeAssetSymbol] = event;
                });
                break;
            case UPDATE_MARKET_DATA_CANDLE:
                action.payload.forEach((event) => {
                    if (!draft.marketDataCandle[event.symbol]) {
                        draft.marketDataCandle[event.symbol] = {};
                    }
                    draft.marketDataCandle[event.symbol][event.time] = event;
                });
                break;

            case ADD_MARKET_DATA_WATCH_ACTION:
                if (action.payload.symbol && action.payload.fromComponentName) {
                    draft.marketDataWatchers.push({
                        symbol: action.payload.symbol,
                        fromComponentName: action.payload.fromComponentName,
                    });
                }
                break;

            case REMOVE_MARKET_DATA_WATCH_ACTION:
                draft.marketDataWatchers = state.marketDataWatchers
                    .filter(item => !(item.fromComponentName === action.payload.fromComponentName && (!action.payload.symbol || item.symbol === action.payload.symbol)))
                break;

            case ADD_MARKET_DATA_CANDLE_WATCH_ACTION:
                if (action.payload.symbol && action.payload.fromComponentName) {
                    draft.marketDataCandleWatchers.push({
                        symbol: action.payload.symbol,
                        fromComponentName: action.payload.fromComponentName,
                    });
                }
                break;

            case REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION:
                draft.marketDataCandleWatchers = state.marketDataCandleWatchers
                    .filter(item => !(item.fromComponentName === action.payload.fromComponentName && (!action.payload.symbol || item.symbol === action.payload.symbol)))
                break;

            case GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS:
                draft.stat_pl = action.payload;
                break;

            case GET_LITE_TRADE_MARKET_SUCCESS:
                draft.collections = action.payload?.collections || [];
                draft.collectionsIsLoading = false;
                draft.widgets = action.payload?.widgets || [];
                break;

            case GET_LITE_TRADE_MARKET_COLLECTION_SUCCESS:
                const collectionIndex = _.findIndex(draft.collections, { collection_key: action.payload.collection_key });
                if (collectionIndex === -1) {
                    draft.collections = [...draft.collections, action.payload]
                } else {
                    draft.collections.splice(collectionIndex, 1, action.payload);
                }
                break;

            case UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_ACTION:
                draft.marketFavoriteInProgress = true;
                break;
            case UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_SUCCESS:
                draft.marketFavoriteInProgress = false;
                break;
            case UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_FAILURE:
                draft.marketFavoriteInProgress = false;
                break;
            case UPDATE_LITE_TRADE_CHART_TIMEFRAMES:
                draft.chart.timeframes = action.payload;
                // TODO: move it in middleware
                localStorage.setItem(TRADING_VIEW_SELECTED_TIMEFRAMES_KEY, action.payload);
                break;

            case UPDATE_LITE_TRADE_CHART_DATA_READY:
                draft.chart.dataReady = action.payload;
                break;

            case INIT_UPS_DOWNS_COLLECTION_ACTION:
                draft.collectionUpsDownsIsLoading = true;
                break;
            case INIT_UPS_DOWNS_COLLECTION_SUCCESS:
                draft.collectionUpsDownsIsLoading = false;
                draft.collectionUpsDownsAssetsList = action.payload;
                break;
            case INIT_UPS_DOWNS_COLLECTION_FAILURE:
                draft.collectionUpsDownsIsLoading = false;
                break;

            case CLOSE_ALL_POSITIONS_ACTION:
                draft.closeAllPositionsInProgress = true;
                break;
            case CLOSE_ALL_POSITIONS_SUCCESS:
                draft.closeAllPositionsInProgress = false;
                break;
            case CLOSE_ALL_POSITIONS_FAILURE:
                draft.closeAllPositionsInProgress = false;
                break;

            case UPDATE_LITE_TRADE_POSITION_ACTION:
                draft.updatePositionInProgress = true;
                break;
            case UPDATE_LITE_TRADE_POSITION_SUCCESS:
                draft.updatePositionInProgress = false;
                break;
            case UPDATE_LITE_TRADE_POSITION_FAILURE:
                draft.updatePositionInProgress = false;
                break;

            case UPDATE_LITE_TRADE_ORDER_ACTION:
                draft.updateOrderInProgress = true;
                break;
            case UPDATE_LITE_TRADE_ORDER_SUCCESS:
                draft.updateOrderInProgress = false;
                break;
            case UPDATE_LITE_TRADE_ORDER_FAILURE:
                draft.updateOrderInProgress = false;
                break;

            case SET_DESKTOP_TRADE_TABLE_MODE:
                draft.desktopTradeTableMode = action.payload;
                setDesktopTradeTableMode(action.payload);
                break;

            case UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_SUCCESS:
                draft.positionPlLastSeenSigns[action.payload.accountCode] = action.payload.data;
                break;
            case UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_POSITION_CODE_ACTION:
                draft.positionPlLastSeenSigns[action.payload.accountCode][action.payload.positionCode] =
                    action.payload.sign;
                break;
            case SET_CHART_DRAW_PANEL_OPENED:
                draft.isChartDrawPanelOpened = action.payload;
                break;

            default:
                return state;
        }
    });

export default liteTradeReducer;
